import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputDatepickerNewComponent } from '../../components/input-datepicker-new/input-datepicker-new.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import Session from '../../utils/session.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	standalone: true,
	selector: 'modal-terminate-dependent',
	templateUrl: './modal-terminate-dependent.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, InputDatepickerNewComponent, ItemNotificationComponent, FormsModule ]
})
export class ModalTerminateDependentComponent implements OnInit {
	private config: Config = inject(Config);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private dialogRef = inject(MatDialogRef<ModalTerminateDependentComponent>);
	private data = inject(MAT_DIALOG_DATA);

	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		Object.keys(this.data).forEach(key => this.vm[key] = this.data[key]);
		
		this.vm.getName = this.getName;
		this.vm.submit = this.submit;
		this.vm.close = this.close;
		
		this.initialize();
	}
	
	initialize() {
		this.vm.loaderTimeout = this.angularHelperService.createTimer(() => { this.vm.processing = true; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_INIT']);
		
		this.vm.uid = 'tw-' + Date.now();
		this.vm.invitation = this.vm.invitation;
		this.vm.user = this.session.getSession().user;
		var minDate;
		if (this.vm.user.service.insuranceChangesInFuture) {
			var today: any = new Date();
			minDate = new Date();
			minDate.setDate(today.getDate() + this.config.getOtherConfig().INSURANCE_CHANGE_DELAY_IN_DAYS);
			this.vm.minDate = minDate;
		} else {
			this.vm.minDate = new Date(2020, 0, 1);
		}
		this.vm.getExistingTerminationWarning = this.getExistingTerminationWarning;
		
		if (!this.vm.invitation.dependent.terminationDate) {
			this.vm.invitation.dependent.terminationDate = minDate ? minDate : new Date();
		}
		
		this.angularHelperService.cancelTimer(this.vm.loaderTimeout);
		if (this.vm.processing) this.angularHelperService.createTimer(() => { this.vm.processing = false; },
			this.config.getOtherConfig()['LOADER_TIMEOUT_DELAY']);
		
		this.vm.initialized = true;
	}
	
	getName() {
		return this.vm.invitation ? this.vm.invitation.firstName + ' ' + this.vm.invitation.lastName : '';
	}
	
	submit() {
		this.vm.processing = true;
		var terminationDate: any = this.angularHelperService.copy(this.vm.invitation.dependent.terminationDate);
		this.vm.invitation.dependent.terminationDate = moment(this.vm.invitation.dependent.terminationDate).startOf("day")
			.utcOffset(0, true).toDate()
		this.restService.saveBusinessClientUserDependentDeactivate(this.vm.invitation.dependent)
			.then((response) => {
				this.vm.invitation.existingTerminationDate = terminationDate;
				if (!response.active) {
					this.vm.invitation.dependent.active = false;
					this.vm.invitation.processing = false;
				}
				this.dialogRef.close(response);
			})
			.catch((error) => {
				console.log(error);
				this.vm.processing = false;
			});
	}
	
	getExistingTerminationWarning() {
		return this.angularFilterHelperService.translate('Business_Client_User.Existing_Deactivation_Date')
			+ ": "
			+ this.angularFilterHelperService.formatDate(this.vm.invitation.existingTerminationDate, 'dd.MM.yyyy');
	}
	
	close() {
		this.dialogRef.close(undefined);
	}
	
}